import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom';
import { HashLink as Link, NavHashLink as NavLink } from 'react-router-hash-link';
import PropTypes from 'prop-types'
import { topics, subTopics, offTopics } from './Navigation'

import './App.css';
import './AppLib.css';
import './AppRespond.css';

export default class App extends Component {
  render() {
    const navs = [...topics, ...subTopics, ...offTopics];

    return (
      <div className="App">
        <BrowserRouter>
          <div>
            <Route exact path="/" render={() => (
              <Redirect to="/home" />
            )} />

            <Route component={ScrollToTop} />
            <Route path={`/:id`} component={Header} />
            <Route path={`/:id`} component={HeaderCarousel} />
            <Route path={`/home`} component={HeaderDatenschutz} />
            {navs.map(({ id, componentPath }) => (
              <div key={id}>
                <Route path={`/${id}`} component={require(`${componentPath}`).default} />
              </div>
            ))}
            <Route path={`/:id`} component={Footer} />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

function Header({ match }) {
  const navs = [...topics, ...subTopics, ...offTopics];
  const topic = navs.find(({ id }) => id === match.params.id);

  return (
    <header className="header navbar navbar-default navbar-fixed-top">
      <div id="main-navigation">

        <div className="navbar-header">
          <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#mainmenu">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <div className="navbar-title">
          </div>

          <Link to={`/home`} className="navbar-brand">
            <img src="https://pailer.com/files/pailer-logo.PNG" />
          </Link>
        </div>

        <nav id="mainmenu" className="navbar-collapse collapse navbar-collapse bs-navbar-collapse" role="navigation">
          <ul className="nav navbar-nav">
            {topics.map(({ id, name }) => (
              <li key={id} className={id === topic.id ? 'active' : undefined}>
                <NavLink data-toggle="collapse" data-target=".navbar-collapse.in" to={`/${id}`} activeClassName="active">{name}</NavLink>
              </li>
            ))}
          </ul>
          <ul className="nav navbar-nav navbar-right">
            {subTopics.map(({ id, name }) => (
              <li key={id} className={id === topic.id ? 'active' : undefined}>
                <NavLink data-toggle="collapse" data-target=".navbar-collapse.in" to={`/${id}`} activeClassName="active">{name}</NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <a><div id="submenu-show"></div></a>

        <nav id="submenu" className="navbar-collapse" style={{height:(topic.resources.length > 0 ? '100%' : '0px')}} role="navigation">
          <ul className="nav navbar-nav">

            {topic.resources.map(({ name }) => (
              <li key={name}>
                <NavLink smooth to={`#${name}`} activeClassName="active">{name}</NavLink>
              </li>
            ))}

          </ul>
        </nav>
      </div>
    </header>
  );
}

function HeaderCarousel({ match }) {
  const navs = [...topics, ...subTopics, ...offTopics];
  const topic = navs.find(({ id }) => id === match.params.id);

  return (
    <div id="header-carousel" className={`carousel ${topic.id === "home" ? "small" : ""} slide ${match.params.id}`} data-interval="30000" data-ride="carousel">
      <div id={`header-carousel-inner-${match.params.id}`} className="carousel-inner">
        <div className="item active">
          <div className="wrapper" id="first"></div>
        </div>
        <div className="item">
          <div className="wrapper" id="second"></div>
        </div>
        <div className="item">
          <div className="wrapper" id="third"></div>
        </div>
      </div>
    </div>
  )
}


function HeaderDatenschutz({ match }) {
  return (
    <div id="cookiePopup">
      <div>
        <span>Diese Webseite verwendet Cookies. </span>
        <span>
          Cookies werden zur Benutzerführung und Webanalyse verwendet und helfen dabei, diese Webseite besser zu machen. Mehr Infos
            hier:
            <b>
            <Link to={`/impressum-datenschutzhinweise`}>Datenschutzerklärung</Link>
          </b>
        </span>
        <button onClick={hideCookiePopup} type="button">Ok</button>
      </div>
    </div>
  )
}

function RespondHtml(params) {
  return (<div></div>);
}

function Footer() {
  return (
    <footer role="contentinfo">
      <div id="block-3" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
        <div className="col col-md-12"></div>
      </div>
      <div id="footer-block-2" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
        <div className="col col-md-12">
          <p id="p-2" className="text-center" data-i18n="56ca1192976d2.p-2">Firma&nbsp;Kurt Pailer GmbH &amp; Co. KG&nbsp;| Kinzigstraße 4 | 75196 Remchingen</p>
          <p id="p-3" className="text-center" data-i18n="56ca1192976d2.p-3"><a href="tel:+497232372506">07232 / 37 25 06</a></p>
          <p id="p-4" className="text-center" data-i18n="56ca1192976d2.p-4"><a href="mailto:info@pailer.com">info@pailer.com</a></p>          
        </div>
        <div className="col col-md-6 pull-right">
          <a href="https://www.facebook.com/KurtPailerGmbHCoKG/" target="_blank">
                      <span className="fa-stack fa-4x">
                        <i className="fa fa-facebook-official fa-stack-1x text-primary"></i>
                      </span>
                     </a> 
          <a href="https://www.instagram.com/fa.kurtpailer/" target="_blank">
                      <span className="fa-stack fa-4x">
                        <i className="fa fa-instagram fa-stack-1x text-primary"></i>
                      </span>
          </a> 
        </div>
        <div className="col col-md-12">
          <ul className="nav pull-right">
            {offTopics.map(({ id, name }) => (
              <li key={id}>
                <NavLink to={`/${id}`} activeClassName="active">{name}</NavLink>
              </li>
            ))}
          </ul>
          <p id="p-1" data-i18n="56ca1192976d2.p-1"></p>
         </div>        
      </div>
    </footer>
  );
}

function hideCookiePopup() {
  var cookiePopup = document.getElementById("cookiePopup");
  cookiePopup.style.display = "none";
}

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
}



// WEBPACK FOOTER //
// ./src/App.js